import React from 'react'
import { Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/system';
import EmailAvatar from '../HomePage/EmailAvatar';

const GenerateButton = styled('button')({
    marginTop: '16px',
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    border: '1px solid #2560CD',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    borderRadius: '12px',
    fontSize: '16px',
    cursor: 'pointer',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});

const DashboardWelcome = () => {
    const navigate = useNavigate();

    return (
        <div style={{ width: '75vw', height: '100vh' }}>
            <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', marginTop: '10px', padding: 10 }}>
                <Typography style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    fontSize: '20px',
                    marginTop: 10
                }}>
                    Your journey of self discovery begins here
                </Typography>
                <EmailAvatar />
            </div>
            <Typography style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 550,
                fontSize: '14px',
                marginTop: '15px',
            }}>
                <ul>Hi there!<br />
                    Strengths Analyzer derives your demonstrated strengths from your extra curricular activities since schooling as well as professional engagements:
                    <br />Please include your participation in activities such as:
                    <br /><br />
                    <ul>
                        <li>Internships, Project Works & Freelancing</li>
                        <li>Study abroad programs, Research etc</li>
                        <li>Sports, Martial Arts, Gymnastics etc</li>
                        <li>Clubs: Cultural, Professional, Personality development etc</li>
                        <li>Volunteer activities, Community service organization & Social Activism</li>
                        <li>Event organizations, Fairs, Exhibitions & other Participations</li>
                        <li>Olympiads & other Academic Competitions </li>
                        <li>Mentorship programs </li>
                        <li>Leadership development programs</li>
                        <li>Student Government & Model UN etc.</li>
                        <li>NCC, Scouts & Guide, Youth Exchange Programs</li>
                        <li>Photography, Videography & Performing Arts</li>
                        <li>Social Media Influencer, Blogger, Vlogger etc.</li>
                        <li>Public speaking, Tutoring, Coaching</li>
                        <li>Intrapreneurship/ Entrepreneurship etc</li>
                    </ul>
                </ul>
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px', width: '100%' }}>
                <GenerateButton onClick={() => { navigate("/userdetails"); }}>Start Assessment</GenerateButton>
            </div>
        </div>
    )
}

export default DashboardWelcome;
